import React from "react";
import AdminNavbar from "../Layout/AdminNavbar";
import MyInterviewsPage from "../placement/MyInterviewsPage";

export default function MyInterviewsAdminPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <AdminNavbar />
      <MyInterviewsPage />
    </div>
  );
}
